export default "../fonts/akzidgrtskprolig-webfont.61142a28cf2fd0b36bd63edea853a641.woff";